import axios from "axios";
import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

import { getUserLocalData } from "../lib/helper";
import { getGoogleTextToSpeechService } from "../services/TextToSpeechService";
import { useLanguage } from "../context/LanguageContext";

export default function GoogleTextToSpeech({
  transcript,
  listening,
  saveConversation,
  resetTranscript,
  isPopUpOpen,
}) {
  const { token, patient_id, session_id, validPatientId , user_name} = getUserLocalData();
  const { language, languageName } = useLanguage();
  const [message, setMessage] = useState(transcript);
  const [isLoading, setLoading] = useState(false);
  const [isAudioLoading, setAudioLoading] = useState(false);

  const [messageResponse, setMessageResponse] = useState("");
  const [audio, setAudio] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [isAudioCanPlay, setIsAudioCanPlay] = useState(false);

  //Effect run when voice completed and listing state change
  useEffect(() => {
    if (validPatientId) {
      if (!listening && transcript && transcript.trim()) {
        getMessageData(new Event("submit"));
      }
      if (listening) {
        handleStop();
        resetAudio();
      }
    }
  }, [listening]);

  //Effect run when voice message has change
  useEffect(() => {
    if (transcript?.trim()) {
      setMessage(transcript);
      setMessageResponse("");
    }
  }, [transcript]);

  useEffect(() => {
    if (isPopUpOpen) {
      setMessage("");
    }
  }, [isPopUpOpen]);

  //Effect run when api response get and its automatically start to speak
  useEffect(() => {
    messageResponse && messageResponse?.trim() && getAudio();
  }, [messageResponse]);

  // Cleanup when the component unmounts or when audio is no longer needed
  useEffect(() => {
    return () => {
      handleStop();
    };
  }, [audio]);

  const handleStop = () => {
    if (audio) {
      audio.pause(); // Pause the audio
      audio.currentTime = 0; // Reset the audio to the beginning
    }
  };

  const resetAudio = () => {
    setAudioUrl(null);
    setIsAudioCanPlay(null);
  };

  const getAudio = async () => {
    try {
      setAudioLoading(true);
      const response = await getGoogleTextToSpeechService(messageResponse, language);
      setAudioLoading(false);
      const audio = new Audio(response);
      setAudio(audio);

      audio.play().catch((error) => {
        console.error("Error playing audio:", error);
        setIsAudioCanPlay(false);
      });

      setAudioUrl(response);
    } catch (error) {
      setAudioLoading(false);
      console.log("errrr", error?.response);
    }
  };

  const getMessageData = async () => {
    try {
      setLoading(true);
      const userInput = transcript.trim();
      resetTranscript();
      const patient_id_formatted = patient_id.replace(/^"|"$/g, "");
      let url = `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&session_id=${session_id}&patient_id=${patient_id_formatted}&language=${languageName}`;
      if (user_name) {
        url += `&practitioner=${user_name}`;
      }
      const response = await axios.post(url);
      setLoading(false);
      if (response?.data) {
        //Note: here only a first assistant message has shown
        
        if (response?.data?.session_id) {
          localStorage.setItem("session_id", response.data.session_id);
        }

        const assistantMessageData = response.data?.conversation?.filter(
          (msg) => msg.role === "model"
        );
        const assistantMessage =
          assistantMessageData?.[assistantMessageData?.length - 1];
        const userMessage = { role: "user", content: userInput };

        saveConversation([userMessage, assistantMessage]);
        setMessageResponse(assistantMessage?.content);
      }
    } catch (error) {
      setLoading(false);
      resetTranscript();
      console.log(error?.response);
    }
  };

  if (message && message !== "undefined") {
    return (
      <>
        <Box
          style={{
            margin: 20,
            padding: 20,
            paddingBottom: 150,
          }}
        >
          <Typography
            align="center"
            fontSize={20}
            color="white"
            className="font-w-400 white-color"
          >
            {message}
          </Typography>
          {validPatientId ? (
            <Box
              align={"center"}
              sx={{ marginTop: "10px", color: "white", fontSize: 20 }}
            >
              {isLoading ? <CircularProgress size={20} color="white" /> : null}
              {messageResponse ? (
                <div style={{ whiteSpace: "pre-wrap" }}>{messageResponse}</div>
              ) : null}
              {audioUrl && !isAudioLoading && isAudioCanPlay === false && (
                <div>
                  <audio controls>
                    <source src={audioUrl} type="audio/mp3" />
                  </audio>
                </div>
              )}
            </Box>
          ) : null}
        </Box>
      </>
    );
  }
  return null;
}
